import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="flex flex-col md:flex-row justify-between gap-8 mb-12">
          <div className="max-w-sm">
            <h3 className="text-xl font-heading font-bold text-background-50 mb-3">Mulebuy Spreadsheets</h3>
            <p className="text-sm text-foreground-300 leading-relaxed">
              Your trusted resource hub for mulebuy spreadsheet guides, product sourcing data, and comprehensive category navigation. Explore organized product databases and sourcing insights all in one place.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Categories</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 7).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">More Categories</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(7).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Resources</h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/what-is-mulebuy-spreadsheet"
                className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                What is Mulebuy Spreadsheet
              </Link>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Mulebuy Spreadsheet
              </a>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                Buy It Now
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Legal</h4>
            <div className="flex flex-col gap-2">
              <p className="text-sm text-foreground-400">Informational website only</p>
              <p className="text-sm text-foreground-400">No product selling</p>
              <p className="text-sm text-foreground-400">External links not controlled</p>
              <p className="text-xs text-foreground-500 mt-2">© 2026 Mulebuy Spreadsheets. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}